import React from 'react';
import { Link } from 'react-router';
import { formatNumber } from './../../utils/dyzio';

import SocialBar from './../social-bar';

const Card = ({ influencer }) => {
  const youtubeStats = influencer.aggregateYoutubeChannelStatistics;
  const twitterStats = influencer.twitterStatistics;
  const facebookStats = influencer.facebookStatistics;
  const instagramStats = influencer.instagramStatistics;
  const youtubeCount = (youtubeStats && youtubeStats.subscriberCount) || 0;
  const twitterCount = (twitterStats && twitterStats.followersCount) || 0;
  const facebookCount = (facebookStats && facebookStats.likes) || 0;
  const instagramCount = (instagramStats && instagramStats.followersCount) || 0;
  const total = influencer.totalSocialReach;
  return (
    <div className="card loaded">
      <Link to={`/influencer/${influencer.slug}`}>
        <img className="card-photo" src={influencer.thumbnail} alt={influencer.name} />
      </Link>
      <div className="card-content">
        <Link to={`/influencer/${influencer.slug}`}>
          <h3>{influencer.name}</h3>
        </Link>
        <p className="uppercase small light">{influencer.countryCode ? influencer.countryCode : '-'}</p>
        <span>
          { (influencer.categories || []).join(', ') }
        </span>
        <h2>{ formatNumber(total) }</h2>
        <p className="total-reach">Total reach</p>
        <SocialBar
          item={{
            influencer: influencer.id,
            data: {
              youtube: youtubeCount,
              facebook: facebookCount,
              instagram: instagramCount,
              twitter: twitterCount,
            },
          }}
        />
        <hr />
        <Link className="link-to-profile" to={`/influencer/${influencer.slug}`}>view profile</Link>
      </div>
    </div>
  );
};

Card.propTypes = {
  influencer: React.PropTypes.object.isRequired,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/profile-card/index.js